import React from 'react';

class ImageText extends React.Component {
    render() {
        const { image, text } = this.props;
        return (
            <div className="image-text">
                <img src={image} className="image-text__image"/>
                {text && <div className="image-text__text">{text}</div>}
            </div>
        )
    }
}

module.exports = ImageText;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/image-text/Component/index.jsx